import type { TutorialSection } from '../types'

export function buildBreadcrumbs(section: TutorialSection, prefix?: string): string[] {
  const crumbs = prefix ? [prefix] : []

  for (const segment of section.category ?? []) {
    crumbs.push(
      segment
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    )
  }

  crumbs.push(section.title)
  return crumbs
}
